import { Navigate } from 'react-router-dom';

import { LoginVisionPanel } from '../components/LoginVisionPanel';
import { OtpLoginForm } from '../components/OtpLoginForm';
import { useSession } from '../hooks/useSession';
import { messages } from '@/shared/constants/messages';
import { LoadingState } from '@/shared/components/LoadingState';

/**
 * Tela cheia, partida em duas metades: o papel azul da igreja
 * (`LoginVisionPanel`) e o formulário. Nenhum cartão, nenhuma margem — as duas
 * superfícies vão até a borda do vidro.
 *
 * **É a única tela do painel que sangra assim, e é de propósito.** Todo o resto
 * do sistema segue a metáfora das duas superfícies (ver o topo de
 * `styles/index.css`): a MESA cinza com o PAPEL branco apoiado nela. Aqui não
 * existe mesa — não há navegação, não há nada em volta para emoldurar. Um
 * cartão centralizado num monitor de 27" transformaria a peça da igreja num
 * selo de 400px cercado de cinza, e o reconhecimento da marca (que é a função
 * desta tela) mora justamente no tamanho dela.
 *
 * `lg:grid-cols-2` e não `md`: abaixo de 1024px cada coluna ficaria com ~350px
 * e a frase de visão quebraria em cinco linhas ao lado de um formulário
 * espremido. Uma coluna só, com a faixa azul no topo, é melhor tela do que
 * duas colunas estreitas.
 */
export function LoginPage() {
  const { session, isLoading } = useSession();

  // Já autenticado: não faz sentido mostrar o formulário de novo.
  if (isLoading) return <LoadingState label="Verificando sessão…" />;
  if (session) return <Navigate to="/" replace />;

  return (
    <div className="flex min-h-screen flex-col bg-card lg:grid lg:grid-cols-2">
      <LoginVisionPanel />

      {/* `flex-1` no celular para o branco ocupar o que sobra da tela abaixo da
          faixa azul — sem ele, uma tela alta termina em mesa cinza e a
          página parece cortada no meio. */}
      <div className="flex flex-1 items-center justify-center px-6 py-10 sm:px-10 lg:px-12 xl:px-16">
        <div className="w-full max-w-sm">
          <OtpLoginForm />

          {/* Fora do `<form>`: não é instrução de preenchimento, é o que fazer
              quando o formulário NÃO é para você. */}
          <p className="mt-8 border-t border-border pt-5 text-xs leading-relaxed text-muted-foreground">
            {messages.auth.noSelfSignup}
          </p>
        </div>
      </div>
    </div>
  );
}
